module.exports = __webpack_public_path__ + "assets/3bd5d3c47b82055ae21c2353f6698f50.mp4";